import Logout from '../Pages/Logout/Logout';

export const logoutRoutes = [{ path: '/', component: Logout, listable: true }];

export default logoutRoutes;
